<template>
    <div
        class="useful-services__block useful-services-block useful-services-block_bg"
        :style="backgroundImage('useful-services/map.png')"
    >
        <h4 class="useful-services-block__title">
            Офисы, банкоматы и&nbsp;терминалы
        </h4>
        <div class="useful-services-block__info">
            <p class="useful-services-block__desc">
                Вы&nbsp;можете выбрать на&nbsp;карте <br> или&nbsp;ввести адрес вручную
            </p>
        </div>
        <UILink
            href="/about/offices-and-atms"
            class="useful-services-block__btn"
            link-class="ui-button outlined"
            label="Найти ближайший"
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {UILink} from '@cibsite/ui-components-vue2';

import {useCompressedBackgroundImage} from '@/core/composables/useCompressedBackgroundImage';

export default defineComponent({
    name: 'OfficesMapSmall',
    components: {
        UILink,
    },
    setup() {
        const {backgroundImage} = useCompressedBackgroundImage();

        return {
            backgroundImage,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/services';
</style>
